<template>
<div class="w-full h-full">
  <div id="loader" v-if="loading" style="  height: 100vh; padding-bottom: 100px">
    <center>
      <div class="loading-animation"></div>
    </center>
  </div>
  <el-card v-else class="box-card center-float" style="margin-top: 60px; margin-bottom: 100px;">
    <div slot="header" class="clearfix">
      <p class="text-center text-header">Manage Accounts</p>
      <p class="text-center text-header__sub">Switch accounts or sign in and sign out</p>
    </div>
    <div v-if="!loading">
      <div v-for="(account, i) in trading_accounts" :key="`tra-${i}`" class="text item hover-effect account-item" v-bind:class="{'selected-account' : account.account_id === selected_trading_account}" @click="selectTradingAccount(account)">
        <!-- Checkmark in top-right -->
        <img v-if="account.account_id === selected_trading_account" :src="require('@/assets/check.png')" class="checkmark" height="20" width="20" />

        <el-row>
          <el-col :span="4" class="content">
            <img class="broker-img" :src="brokers[account.broker]" />
          </el-col>
          <el-col :span="20">
            <p class="m-0 item__title">{{ account.account_id }}</p>
            <p class="m-0 item__description">{{ account.broker }}</p>
            <p class="m-0 item__timestamp">Last logged at {{ displayDate(account.last_login_date) }}</p>
          </el-col>
        </el-row>
      </div>
      <div v-for="(account, i) in broker_verification_accounts" :key="`bva-${i}`" class="text item disabled">
        <el-row>
          <el-col :span="4" class="content">
            <img class="broker-img" :src="brokers[account.broker]" />
          </el-col>
          <el-col :span="20">
            <p class="m-0 item__title">{{ account.account_id }}</p>
            <p class="m-0 item__description">{{ account.broker }}</p>
            <p class="m-0">
              <el-tag v-if="account.status === 'rejected'" size="mini" type="danger">Rejected</el-tag>
              <el-tag v-if="account.status === 'pending'" size="mini" type="warning">Pending</el-tag>
            </p>
          </el-col>
          <div class="remove__item" @click="handleDelete(account, i)">
            <i class="el-icon-close"></i>
          </div>
        </el-row>
      </div>
      <div style=" block;padding: 0px 20px 30px;text-align: center;">
        <el-link style=" color: #fff; display:" @click="handleAddItem()">Submit new trading account</el-link>
      </div>
      <!-- <div class="text item add-item" @click="handleAddItem()">
                    <el-row>

  
                        <el-col :span="4" class="content">
                            <img class="broker-img add-item" :src="broker_image" />
                        </el-col>
                        <el-col :span="20">
                            <p class="m-0 item__title add_new">Submit new trading account</p>
                            <p class="m-0">

                            </p>
                        </el-col>
                        <div class="add__item" >
                            <i class="el-icon-plus"></i>
                        </div>
                    </el-row>
                </div> -->
    </div>
    <el-row :gutter="16">
      <el-col :span="8">
        <el-button size="small" type="success" class="w-full" @click="logout()">LOGOUT</el-button>
      </el-col>
      <el-col :span="16">

        <el-button size="small" type="success" :disabled="!trading_accounts" class="w-full" @click="handleProceed()">PROCEED TO {{ broker_name }}</el-button>
      </el-col>
    </el-row>
  </el-card>

  <el-dialog title="Submit new trading account" :visible.sync="add_broker_dialog" width="30%" id="add_broker_dialog" :before-close="handleClose">
    <div>

      <el-form id="addBrokerForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="top">
        <el-form-item label="Email" prop="email">
          <el-input v-model="ruleForm.email" size="medium" type="email"></el-input>
        </el-form-item>
        <el-form-item label="Account ID" prop="account_id">
          <el-input v-model="ruleForm.account_id" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="Broker" prop="broker">
          <el-input v-model="ruleForm.broker" size="medium"></el-input>
        </el-form-item>

        <!-- <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">Create</el-button>
                <el-button @click="resetForm('ruleForm')">Reset</el-button>
            </el-form-item> -->
      </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="success" @click="handleClose()">Cancel</el-button>
      <el-button size="small" type="success" @click="handleConfirm('ruleForm')">Confirm</el-button>

    </span>
  </el-dialog>

</div>
</template>

<script>
import {
  formatDate
} from '/src/assets/js/helpers';
export default {
  name: "ManageComponent",
  data() {
    return {
      loading: false,
      ruleForm: {
        email: '',
        account_id: '',
        broker: ''
      },
      broker_name: 'SmartCharts',
      trading_accounts: [],
      broker_image: '',
      add_broker_dialog: false,
      broker_verification_accounts: [],
      brokers: {
        capitalindex: 'https://55brokers.com/wp-content/uploads/2018/05/Capital-Index-logo.png',
        smartcharts: 'https://th.bing.com/th/id/OIP.x_-H9j_NBl6P-GP1VlGdhgHaHa?rs=1&pid=ImgDetMain'
      },
      selected_trading_account: null,
      app_url: '',
      new_selected_broker: null,
      rules: {
        email: [{
            required: true,
            message: 'Please input email address',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change']
          }
        ],
        account_id: [{
          required: true,
          message: 'Please input Broker Account ID',
          trigger: 'blur'
        }],
        broker: [{
          required: true,
          message: 'Please input Broker Name',
          trigger: 'blur'
        }]
      }
    }
  },
  async mounted() {
    this.loading = true
    // console.log(this.new_selected_broker)
    console.log(this.new_selected_broker, 'this is the managecompoennt')
    if (!this.new_selected_broker) {
      this.fetchUserDetails('first_load');
    }

    if (!this.$cookies.get('web_session_id')) {
      this.logout();
      this.loading = false
    }
    // await this.generateToken(); // wait for session token
    // this.fetchUserDetails();    // then fetch user info
  },
  methods: {
    handleClose() {
      this.add_broker_dialog = false
      this.ruleForm = {
        account_id: '',
        broker: ''
      }
    },
    async handleConfirm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const axios = require('axios');

          // Build payload for verification
          const payload = {
            email: this.ruleForm.email,
            broker: this.ruleForm.broker,
            account_id: this.ruleForm.account_id
          };

          const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-SESSION-ID': this.$cookies.get('web_session_id')
          };

          const url = process.env.VUE_APP_API_URL + `/v1/users/trading-accounts/verification`;

          try {
            const response = await axios.post(url, payload, {
              headers
            });
            const result = response.data;
            console.log('Verification response:', result);
            if (response) {
              this.$notify.success({
                title: 'Success',
                message: 'Submited succesfuly',
                // duration: 0
              });
            }

            this.add_broker_dialog = false;
          } catch (error) {
            console.error("Verification request failed:", error.response?.data || error.message);
            this.add_broker_dialog = false;
          } finally {
            this.loading = false;
          }

        } else {
          console.log('error submit!!');
          this.add_broker_dialog = false;
          return false;
        }
      });
    },

    displayDate(date) {
      return formatDate(date); // You can also pass locale and options
    },
    async generateToken() {
      const axios = require('axios');
      const token = this.$cookies.get('token')
      const expiresAt = this.$cookies.get('expires_at')

      // Check if token is still valid
      if (expiresAt) {
        const now = new Date();
        const expiry = new Date(expiresAt);

        if (now < expiry) {
          console.log("Session token is still valid.");
          this.loading = false
          return; // skip if valid
        }
      }

      const url = process.env.VUE_APP_API_URL + `/api/tokens/session?token=${token}`;

      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          withCredentials: false
        });

        const session_details = response.data;
        // localStorage.setItem('session_token', session_details.token);
        this.$cookies.set('session_token', session_details.token)
        this.$cookies.set('expires_at', session_details.expires_at)
        // localStorage.setItem('expires_at', session_details.expires_at);
        console.log("New session token generated:", session_details);
      } catch (error) {
        this.loading = false
        this.logout();
        console.error("Error generating session token:", error.response?.data || error.message);
      }
    },
    fetchUserDetails(value) {
      this.loading = true
      const axios = require('axios');
      const payload = {
        // your request body here
      };

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };

      headers['X-SESSION-ID'] = this.$cookies.get('web_session_id');

      const url = process.env.VUE_APP_API_URL + `/v1/users`;

      try {
        axios.post(url, payload, {
          headers: headers
        }).then(response => {
          const user_details = response.data;

          if (true === user_details.signedIn) {

            // go directly to charts if there is an existing trading account
            // if (user_details.user.selected_trading_account.account_id) {
            //     // this.goToCharts();
            //     this.loading = false
            //     // return;
            // }

            let broker = user_details.user.selected_trading_account.broker

            this.trading_accounts = user_details.user.trading_accounts;
            this.broker_verification_accounts = user_details.user.broker_verification;

            if (user_details.selected_trading_account) {
              this.selected_trading_account = user_details.user.selected_trading_account.account_id;
            }

            let new_trading_accnt_list = this.trading_accounts

            let new_selected_trading_accnt = new_trading_accnt_list.filter(account => account.broker === broker);

            console.log(user_details.user.selected_trading_account, '0000')

            if (value) {

              let new_data = {

                "account_type": new_selected_trading_accnt[0].trading_account_type,
                "account_id": user_details.user.selected_trading_account.account_id,
                "client_id": user_details.user.selected_trading_account.client_id,
                "broker": user_details.user.selected_trading_account.broker
              }

              console.log(new_selected_trading_accnt, 'user_details.user.selected_trading_account')
              this.selectTradingAccount(new_data, 'first_load')
            }

            this.loading = false
          } else {
            this.logout();
          }
        });
        // handle user_details as needed (e.g., store in Vue data)
      } catch (error) {
        this.loading = false
        console.error("Error fetching user details:", error.response?.data || error.message);
      }
    },
    selectTradingAccount(selected, value) {
      console.log(selected, 'thiss')
      // const axios = require('axios');

      // const sessionToken = localStorage.getItem('session_token');
      if (!selected) {
        return
      }
      this.selected_trading_account = selected.account_id
      this.broker_name = selected.broker.toUpperCase()

      let acct_type = ''
      if (value) {

        acct_type = selected.account_type
      } else {
        acct_type = selected.trading_account_type
      }
      let _selected_trading_account = {
        account_id: selected.account_id,
        account_type: acct_type,
        client_id: selected.account_id,
        broker: selected.broker
      }

      this.new_selected_broker = _selected_trading_account

      console.log(this.new_selected_broker, 'teace')
      // console.log(this.new_selected_broker,'_selected_trading_account')
      this.loading = false
      console.log(value)

      // if (!sessionToken) {
      //     console.warn("No session token found.");
      //     // alert('sd')
      //     // this.generateToken()
      //     this.loading = false
      //     return;
      // }

      // if(!value) {
      //     const url = 'https://api.myaccount.tinkerpub.com/v1/users';

      //     var data = {
      //         selected_trading_account: {
      //             account_id: selected.account_id,
      //             account_type: selected.trading_account_type,
      //             client_id: selected.account_id,
      //             broker: selected.broker
      //         }
      //     }

      //     try {
      //         // const response = 
      //         axios.post(url, data);
      //         this.loading = false
      //         // const user_details = response.data;
      //     } catch (error) {
      //         console.error("Error selecting account:", error.response?.data || error.message);
      //         this.loading = false
      //     }
      // } else {
      //     this.loading = false
      // }

    },
    async getBrokers() {
      const axios = require('axios');
      const url = process.env.VUE_APP_API_URL + `/v1/brokers`;

      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          withCredentials: false
        });

        return response.data;
      } catch (error) {
        this.loading = false;
        this.logout();
      }
    },
    async handleDelete(value, index) {
      this.broker_verification_accounts.splice(index, 1)
      const axios = require('axios');
      const url = process.env.VUE_APP_API_URL + `/v1/users/trading-accounts/verification`;
      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-SESSION-ID': this.$cookies.get('web_session_id')
      };

      const payload = {
        id: value.id,
        status: "cancelled"
      };

      try {
        const response = await axios.patch(url, payload, {
          headers
        });
        if (response) {
          this.$notify.success({
            title: 'Success',
            message: 'Successfuly cancelled',
            // duration: 0
          });
        }

      } catch (error) {
        console.error('Failed to cancel verification:', error.response?.data || error.message);
      }

      console.log('delete', value)
    },
    handleAddItem() {
      this.add_broker_dialog = true
    },
    getBrokerAppUrl(new_brokers) {
      let _brokers_arr = this.new_selected_broker
      const brokerKey = _brokers_arr?.broker?.trim().toLowerCase();

      if (brokerKey && new_brokers[brokerKey]) {
        const matchedBroker = new_brokers[brokerKey];
        console.log("Found broker:", matchedBroker);
        return matchedBroker;
      }

      console.warn("Broker not found");
      return null;
    },

    async handleProceed() {
      this.loading = true;
      const axios = require('axios');

      let app_url = '';
      const new_brokers = await this.getBrokers();
      console.log(new_brokers, 'new brokers');

      if (new_brokers) {
        const match_broker = this.getBrokerAppUrl(new_brokers);
        console.log(match_broker, 'match');
        if (match_broker) {
          app_url = match_broker.app_url?.replace(/\s+/g, '').trim();
          console.log(app_url, 'app_url');

        }
      }
      console.log(this.new_selected_broker, 'this.new_selected_broker')
      // return

      const path = this.$route.path; // "/smartchart/register"
      const segments = this.$route.path.split('/'); // ["", "smartchart", "register"]
      const base = window.location.origin; // "http://localhost:8081"
      const query = this.$route.query; // { b: "smartcharts" }

      // Extract subdomain (if present)
      const hostnameParts = window.location.hostname.split('.');
      let subdomain = null;

      // Example: smartchart.localhost or smartchart.example.com
      if (hostnameParts.length > 2) {
        subdomain = hostnameParts[0]; // "smartchart"
      } else if (hostnameParts.length === 2 && hostnameParts[0] !== 'localhost') {
        subdomain = hostnameParts[0]; // "smartchart" (when not localhost)
      }

      console.log('Subdomain:', subdomain);
      console.log('Base URL:', base);
      console.log('Full path:', path);
      console.log('First segment:', segments[1]); // "smartchart"
      console.log('Second segment:', segments[2]); // "register"
      console.log('Query parameter b:', query.b); // "smartcharts"

      let base_ = window.location.origin.replace(/^https?:\/\//, '');

      const env = process.env.VUE_APP_ENV
      if (env === 'local') {
        base_ = 'localhost'
      } else {
        const hostnameParts = window.location.hostname.split('.');
        const root_domain = hostnameParts.reverse()
        base_ = root_domain[1]
      }

      // let my_account_instance = ''
      // if(subdomain) {
      //     my_account_instance = subdomain
      // } else {
      //     my_account_instance = 'smartcharts'
      // }

      let new_data = {
        "selected_trading_account": {
          "account_type": this.new_selected_broker.account_type,
          "account_id": this.new_selected_broker.account_id,
          "client_id": this.new_selected_broker.client_id,
          "broker": this.new_selected_broker.broker,
          "myaccount_instance": base_

        }
      }

      // const payload = this.new_selected_broker;

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-SESSION-ID': this.$cookies.get('web_session_id')
      };

      const url = process.env.VUE_APP_API_URL + `/v1/users/get-token`;

      try {
        const response = await axios.post(url, new_data, {
          headers
        });

        if (response.data.singedIn === false || response.status !== 200) {
            this.loading = false;
            console.error('Invalid response or token not returned');
            this.logout()
            return;
        }
        const _new_user_details = response.data;
        
        if (_new_user_details && _new_user_details.token) {
          const new_token = _new_user_details.token;

          this.app_url = `${app_url}/?token=${new_token}`;

          if (_new_user_details.web_session_id) {
            // localStorage.setItem("web_session_id", _new_user_details.web_session_id);
            this.$cookies.set('web_session_id', _new_user_details.web_session_id);
          }
          const fullSessionUrl = this.$cookies.get('session_token_url')

          if (fullSessionUrl) {
            const baseSessionUrl = fullSessionUrl.split('?')[0];

            const encodedBaseSessionUrl = encodeURIComponent(baseSessionUrl);

            const finalUrl = this.app_url + `&session_token_url=${encodedBaseSessionUrl}`;

            window.location.href = finalUrl;

            console.log('Redirecting to:', finalUrl);
          } else {
            console.error('session_token_url not found in localStorage');
          }
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching user details:", error.response?.data || error.message);
      }
    },
    goToCharts() {
      if(localStorage.getItem('go_to_app_url')) {
        let url = localStorage.getItem('go_to_app_url')
        window.location.href = url + '/?token=' + localStorage.getItem('token') + '&session_token_url=' + encodeURIComponent(this.$cookies.get('session_token_url'))
      } else {
        console.log('no url found!')
      }
      
    },
    logout() {
      console.log('logout')
      localStorage.removeItem('web_session_id')
      localStorage.clear()
      const allCookies = this.$cookies.keys();
      allCookies.forEach((cookie) => {
        this.$cookies.remove(cookie);
      });
      sessionStorage.clear()
      localStorage.setItem('logout', true);
      this.$cookies.set('logout', true)
      this.$cookies.remove('web_session_id')
      // window.location.href = '/';
      this.$router.push('/login');
      this.loading = false
    }
  }
}
</script>

<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  background-image: linear-gradient(to bottom, #3b4978, #383771);
  border: 1px solid #484e85;
  border-radius: 5px;
  cursor: pointer;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}

.item .el-row {
  padding-top: 10px;
  padding-bottom: 10px;
}

.item .broker-img {
  height: 40px;
  width: 40px;
  border-radius: 100%;
  margin-top: 7px;
  margin-bottom: 7px;
}

.text-header {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}

.text-header__sub {
  font-size: 14px;
  color: #ffffffa8;
}

.selected-account {
  border: 2px solid #9bc252;
  border-radius: 5px;
}

.account-item {
  position: relative;
  /* make it a positioned parent */
}

.checkmark {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.item__title {
  font-size: 14px;
  margin-bottom: 5px;
}

.item__description {
  font-size: smaller;
  margin-bottom: 5px;
}

.item__timestamp {
  font-size: 10px;
  color: #ffffffa8;
}
</style>
